/* eslint-disable max-lines */
/* eslint-disable max-params */

import { track } from "common/utils/mixpanel/tracker";

export const trackAiStudioDesignTypeSelected = (params: {
  designType: string;
  prompt: string;
  generatedDesignUrls: string[];
}) => {
  track("ai_studio_design_type_selected", {
    design_type: params.designType,
    prompt: params.prompt,
    generated_design_urls: params.generatedDesignUrls,
    timestamp: Date.now()
  });
};

export const trackAiStudioArtStyleSelected = (params: {
  artStyle: string;
  prompt: string;
  generatedDesignUrls: string[];
}) => {
  track("ai_studio_art_style_selected", {
    art_style: params.artStyle,
    prompt: params.prompt,
    generated_design_urls: params.generatedDesignUrls,
    timestamp: Date.now()
  });
};

export const trackAiStudioOrientationSelected = (params: {
  orientation: string;
  prompt: string;
  generatedDesignUrls: string[];
}) => {
  track("ai_studio_orientation_selected", {
    orientation: params.orientation,
    prompt: params.prompt,
    generated_design_urls: params.generatedDesignUrls,
    timestamp: Date.now()
  });
};

export const trackAiStudioColorModeSelected = (params: {
  colorMode: string;
  prompt: string;
  generatedDesignUrls: string[];
}) => {
  track("ai_studio_color_mode_selected", {
    color_mode: params.colorMode,
    prompt: params.prompt,
    generated_design_urls: params.generatedDesignUrls,
    timestamp: Date.now()
  });
};

export const trackAiStudioGenerateDesignPromptSubmitted = (params: {
  prompt: string;
  designType: string;
  artStyle: string;
  orientation: string;
  colorMode: string;
}) => {
  track("ai_studio_generate_design_prompt_submitted", {
    prompt: params.prompt,
    design_type: params.designType,
    art_style: params.artStyle,
    orientation: params.orientation,
    color_mode: params.colorMode,
    timestamp: Date.now()
  });
};

export const trackAiStudioDesignsGenerated = (params: {
  duration: number;
  prompt: string;
  urls: string[];
  designType: string;
  artStyle: string;
  orientation: string;
  colorMode: string;
}) => {
  track("ai_studio_designs_generated", {
    duration: params.duration,
    prompt: params.prompt,
    urls: params.urls,
    design_type: params.designType,
    art_style: params.artStyle,
    orientation: params.orientation,
    color_mode: params.colorMode,
    timestamp: Date.now()
  });
};

export const trackAiStudioGeneratedDesignChosen = (params: {
  chosenDesignUrl: string;
  prompt: string;
  designType: string;
  artStyle: string;
  orientation: string;
  colorMode: string;
  provider: string;
}) => {
  track("ai_studio_generated_design_chosen", {
    chosen_design_url: params.chosenDesignUrl,
    prompt: params.prompt,
    design_type: params.designType,
    art_style: params.artStyle,
    orientation: params.orientation,
    color_mode: params.colorMode,
    provider: params.provider,
    timestamp: Date.now()
  });
};

export const trackAiStudioRefineDesignCtaClicked = (params: {
  originalDesignUrl: string;
  originalPrompt: string;
  designType: string;
  artStyle: string;
  orientation: string;
  colorMode: string;
}) => {
  track("ai_studio_refine_design_cta_clicked", {
    original_design_url: params.originalDesignUrl,
    original_prompt: params.originalPrompt,
    design_type: params.designType,
    art_style: params.artStyle,
    orientation: params.orientation,
    color_mode: params.colorMode,
    timestamp: Date.now()
  });
};

export const trackAiStudioRefineDesignPromptSubmitted = (params: {
  originalDesignUrl: string;
  refinedPrompt: string;
  originalPrompt: string;
  designType: string;
  artStyle: string;
  orientation: string;
  colorMode: string;
}) => {
  track("ai_studio_refine_design_prompt_submitted", {
    original_design_url: params.originalDesignUrl,
    refined_prompt: params.refinedPrompt,
    original_prompt: params.originalPrompt,
    design_type: params.designType,
    art_style: params.artStyle,
    orientation: params.orientation,
    color_mode: params.colorMode,
    timestamp: Date.now()
  });
};

export const trackAiStudioRefinedDesignGenerated = (params: {
  duration: number;
  refinedDesignUrl: string;
  originalDesignUrl: string;
  refinedPrompt: string;
  originalPrompt: string;
  designType: string;
  artStyle: string;
  orientation: string;
  colorMode: string;
}) => {
  track("ai_studio_refined_design_generated", {
    duration: params.duration,
    refined_design_url: params.refinedDesignUrl,
    original_design_url: params.originalDesignUrl,
    refined_prompt: params.refinedPrompt,
    original_prompt: params.originalPrompt,
    design_type: params.designType,
    art_style: params.artStyle,
    orientation: params.orientation,
    color_mode: params.colorMode,
    timestamp: Date.now()
  });
};

export const trackAiStudioRefineDesignCanceled = (params: {
  originalDesignUrl: string;
  originalPrompt: string;
  designType: string;
  artStyle: string;
  orientation: string;
  colorMode: string;
}) => {
  track("ai_studio_refine_design_canceled", {
    original_design_url: params.originalDesignUrl,
    original_prompt: params.originalPrompt,
    design_type: params.designType,
    art_style: params.artStyle,
    orientation: params.orientation,
    color_mode: params.colorMode,
    timestamp: Date.now()
  });
};

export const trackAiStudioRefinedDesignChosen = (params: {
  originalDesignUrl: string;
  refinedPrompt: string;
  originalPrompt: string;
  designType: string;
  artStyle: string;
  orientation: string;
  colorMode: string;
}) => {
  track("ai_studio_refined_design_chosen", {
    original_design_url: params.originalDesignUrl,
    refined_prompt: params.refinedPrompt,
    original_prompt: params.originalPrompt,
    design_type: params.designType,
    art_style: params.artStyle,
    orientation: params.orientation,
    color_mode: params.colorMode,
    timestamp: Date.now()
  });
};

export const trackAiStudioImageUploadClicked = () => {
  track("ai_studio_image_upload_clicked", {
    timestamp: Date.now()
  });
};

export const trackAiStudioImageUploadImageSelected = (params: {
  fileType: string;
  width: number;
  height: number;
  fileSize: number;
}) => {
  track("ai_studio_image_upload_image_selected", {
    file_type: params.fileType,
    width: params.width,
    height: params.height,
    file_size: params.fileSize,
    timestamp: Date.now()
  });
};

export const trackAiStudioImageUploadImageUploaded = (params: {
  fileType: string;
  width: number;
  height: number;
  fileSize: number;
}) => {
  track("ai_studio_image_upload_image_uploaded", {
    file_type: params.fileType,
    width: params.width,
    height: params.height,
    file_size: params.fileSize,
    timestamp: Date.now()
  });
};
